module.exports = __webpack_public_path__ + "static/media/ico_filter_o.05bb4c27.svg";